document.addEventListener("DOMContentLoaded", async () => {
  const SUPABASE_URL = "https://ntfrymroxvxnlbuqdobd.supabase.co";
  const SUPABASE_KEY = "sb_publishable_g4_4yxUBchg-qNwSy2S4rA_SD2j4P9h";

  let sessionId = localStorage.getItem("sg_session_id");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    localStorage.setItem("sg_session_id", sessionId);
  }

  function getHeaders(prefer = null) {
    const headers = {
      "Content-Type": "application/json",
      "apikey": SUPABASE_KEY,
      "Authorization": "Bearer " + SUPABASE_KEY
    };
    if (prefer) headers["Prefer"] = prefer;
    return headers;
  }

  function setButtonState(btn, active) {
    const icon = btn.querySelector(".favorite-icon");

    if (active) {
      btn.classList.add("active");

      if (icon) {
        icon.textContent = "♥";
      } else {
        btn.innerText = "❤️ Ajouté aux favoris";
        btn.style.background = "#ffe6ea";
        btn.style.color = "#e53935";
        btn.style.border = "none";
        btn.style.borderRadius = "8px";
        btn.style.cursor = "pointer";
        btn.style.fontWeight = "600";
        btn.style.padding = "12px";
      }
    } else {
      btn.classList.remove("active");

      if (icon) {
        icon.textContent = "♡";
      } else {
        btn.innerText = "❤️ Ajouter aux favoris";
        btn.style.background = "";
        btn.style.color = "";
        btn.style.border = "";
        btn.style.borderRadius = "";
        btn.style.cursor = "pointer";
        btn.style.fontWeight = "";
        btn.style.padding = "";
      }
    }
  }

  async function initFavoriteButton(btn) {
    const productId = btn.dataset.productId;
    if (!productId) return;

    let isFavorited = false;

    async function checkFavorite() {
      try {
        const url = `${SUPABASE_URL}/rest/v1/product_events?select=id&product_id=eq.${encodeURIComponent(productId)}&event_type=eq.favorite&session_id=eq.${encodeURIComponent(sessionId)}`;
        const res = await fetch(url, {
          method: "GET",
          headers: getHeaders()
        });

        const data = await res.json();
        isFavorited = Array.isArray(data) && data.length > 0;
        setButtonState(btn, isFavorited);
      } catch (e) {
        console.log("Erreur check favorite", e);
      }
    }

    async function addFavorite() {
      const res = await fetch(`${SUPABASE_URL}/rest/v1/product_events`, {
        method: "POST",
        headers: getHeaders("resolution=ignore-duplicates,return=representation"),
        body: JSON.stringify({
          product_id: productId,
          event_type: "favorite",
          session_id: sessionId
        })
      });

      const txt = await res.text();

      if (res.ok || res.status === 409) {
        isFavorited = true;
        setButtonState(btn, true);
        console.log("FAVORITE ADDED", productId);
      } else {
        console.log("FAVORITE INSERT ERROR", res.status, txt);
      }
    }

    async function removeFavorite() {
      const url = `${SUPABASE_URL}/rest/v1/product_events?product_id=eq.${encodeURIComponent(productId)}&event_type=eq.favorite&session_id=eq.${encodeURIComponent(sessionId)}`;

      const res = await fetch(url, {
        method: "DELETE",
        headers: getHeaders()
      });

      const txt = await res.text();

      if (res.ok) {
        isFavorited = false;
        setButtonState(btn, false);
        console.log("FAVORITE REMOVED", productId);
      } else {
        console.log("FAVORITE DELETE ERROR", res.status, txt);
      }
    }

    await checkFavorite();

    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      e.stopPropagation();

      btn.disabled = true;

      try {
        if (!isFavorited) {
          await addFavorite();
        } else {
          await removeFavorite();
        }
      } catch (e) {
        console.log("Erreur favorite toggle", e);
      } finally {
        btn.disabled = false;
      }
    });
  }

  const favoriteButtons = document.querySelectorAll(".favorite-btn[data-product-id], #favorite-btn[data-product-id]");

  for (const btn of favoriteButtons) {
    await initFavoriteButton(btn);
  }
});